import { GET_DROP_DOWN_LIST_DATA, GET_DROP_DOWN_LIST_DATA_SUCCESS, GET_DROP_DOWN_LIST_DATA_ERROR } from "./actionTypes";

export const getDropDrownList = () => ({
  type: GET_DROP_DOWN_LIST_DATA,
});

export const getDropDownListSuccess = data => ({
  type: GET_DROP_DOWN_LIST_DATA_SUCCESS,
  payload: data,
});

export const getDropDownListError = error => ({
  type: GET_DROP_DOWN_LIST_DATA_ERROR,
  payload: error,
});
